"use client";

import { useEffect, useState } from "react";

import Image from "next/image";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shadcn/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Popover, PopoverContent, PopoverTrigger } from "@/shadcn/ui/popover";
import { CopyIcon } from "lucide-react";
import { differenceInDays, isValid, parseISO } from "date-fns";
import { PortableTextBlock } from "sanity";
import { CTAWrapper } from "@/components/global/utils/CTAWrapper";
import { GROQButton } from "@/sanity/lib/definitions";
import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import img from "@/public/home/flashSalePopupimage.jpg";

export default function FlashSaleDialog({
  text,
  cta,
}: {
  text: PortableTextBlock[];
  cta: GROQButton;
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const shouldShowPopup = localStorage.getItem("flashSalePopupLastTime");

    const lastDate = parseISO(shouldShowPopup || "");

    if (
      shouldShowPopup &&
      isValid(lastDate) &&
      differenceInDays(new Date(), lastDate) < 1
    ) {
      return;
    }

    localStorage.setItem(
      "flashSalePopupLastTime",
      new Date().toISOString().split("T")[0],
    );

    //
    setTimeout(() => {
      setOpen(true);
    }, 5000);
    //
    return () => {};
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-[95vw] md:max-w-[93.375rem] max-h-[90vh] !border-none !bg-white !p-0 rounded-[1.75rem] lg:rounded-[2.75rem] overflow-clip">
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle></DialogTitle>
          </DialogHeader>
        </VisuallyHidden>
        <div className="flex flex-col">
          <Image src={img} alt="statue image" className="!w-full" />
          <div className="px-[5rem] lg:px-[14rem] pt-[4.15rem] lg:pt-[7.15rem] pb-[8rem] lg:pb-[10rem] w-full relative z-[1] flex flex-col ">
            {text && (
              <div
                className="richtext richtext-center
                prose-headings:text-[4rem] lg:prose-headings:text-[5.5rem] prose-headings:mb-[2rem] prose-headings:leading-[-0.09rem]
                prose-p:text-[2rem] prose-p:text-[#103037]/80 prose-strong:font-normal prose-strong:text-[#103037]"
              >
                <PortableText value={text} components={richTextComponent} />
              </div>
            )}
            {cta && (
              <div className="flex relative z-10 justify-center mt-[3.5rem]">
                <CTAButton data={cta} />
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
